var _path, _g, _path2, _g2, _g3, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMintOptionLucidLabs = function SvgIcnMintOptionLucidLabs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icn_mint_option_lucid_labs_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z",
    fill: "#000",
    stroke: "#B030E6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icn_mint_option_lucid_labs_svg__b)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icn_mint_option_lucid_labs_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.978 5.102 5.967 3.445v6.89l-5.967 3.445-5.967-3.445v-6.89l5.967-3.445Z",
    fill: "url(#icn_mint_option_lucid_labs_svg__d)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "icn_mint_option_lucid_labs_svg__f",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 12,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.978 5.102 5.967 3.445v6.89l-5.967 3.445-5.967-3.445v-6.89l5.967-3.445Z",
    fill: "url(#icn_mint_option_lucid_labs_svg__e)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn_mint_option_lucid_labs_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.978 5.102 5.967 3.445v6.89l-5.967 3.445-5.967-3.445v-6.89l5.967-3.445Z",
    fill: "url(#icn_mint_option_lucid_labs_svg__g)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icn_mint_option_lucid_labs_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.418 19.692c1.12-3.437 3.837-6.135 7.274-7.274a.44.44 0 0 0 .28-.56.396.396 0 0 0-.28-.28 11.289 11.289 0 0 1-7.274-7.274.44.44 0 0 0-.56-.28c-.14.04-.24.14-.28.28a11.375 11.375 0 0 1-7.274 7.275.44.44 0 0 0-.28.56c.04.14.14.239.28.279a11.375 11.375 0 0 1 7.275 7.274c.08.24.34.36.56.28.12-.04.219-.14.279-.28Z",
    fill: "url(#icn_mint_option_lucid_labs_svg__i)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.79,
    filter: "url(#icn_mint_option_lucid_labs_svg__j)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.863 9.025-2.89 2.89a.126.126 0 0 0 0 .177l2.89 2.89c.049.048.129.048.178 0l2.889-2.89a.126.126 0 0 0 0-.178l-2.89-2.889a.126.126 0 0 0-.177 0Z",
    fill: "url(#icn_mint_option_lucid_labs_svg__k)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_mint_option_lucid_labs_svg__d",
    x1: 11.978,
    y1: 5.102,
    x2: 11.978,
    y2: 18.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF54CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660FFE",
    stopOpacity: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#640EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_mint_option_lucid_labs_svg__e",
    x1: 11.978,
    y1: 5.102,
    x2: 11.978,
    y2: 18.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF54CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660FFE",
    stopOpacity: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#640EFF",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_mint_option_lucid_labs_svg__g",
    x1: 11.978,
    y1: 5.102,
    x2: 11.978,
    y2: 18.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF54CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660FFE",
    stopOpacity: 0.555
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#640EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icn_mint_option_lucid_labs_svg__i",
    x1: 11.998,
    y1: -4.282,
    x2: 11.998,
    y2: 19.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icn_mint_option_lucid_labs_svg__c",
    x: 4.981,
    y: 4.072,
    width: 13.994,
    height: 15.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.515,
    result: "effect1_foregroundBlur_3163_78676"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icn_mint_option_lucid_labs_svg__h",
    x: 3.496,
    y: 3.496,
    width: 17.005,
    height: 17.005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.029
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.015
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3163_78676"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.252
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_3163_78676",
    result: "effect2_dropShadow_3163_78676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_3163_78676",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icn_mint_option_lucid_labs_svg__j",
    x: 8.565,
    y: 8.647,
    width: 6.774,
    height: 6.774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.031
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.186
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3163_78676"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3163_78676",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icn_mint_option_lucid_labs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icn_mint_option_lucid_labs_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icn_mint_option_lucid_labs_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 -8.513 20.429) scale(22.7861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgIcnMintOptionLucidLabs;